import React, { useState, useEffect } from "react";
import { Row, Col, Descriptions, Typography } from "antd";
import { useIntl } from "react-intl";

import TextIcon from "../../app/generic/textIcon";

import "./listFooter.css";

const { Text } = Typography;

function ListFooter({ consignments }) {
  const intl = useIntl();
  const [countOfValid, setCountOfValid] = useState();
  const [countOfInvalid, setCountOfInvalid] = useState();
  useEffect(() => {
    if (consignments && consignments !== "e") {
      const valid = consignments.reduce(
        (acc, cur) => (cur.valid ? ++acc : acc),
        0
      );
      setCountOfValid(valid);
      setCountOfInvalid(consignments.length - valid);
    }
  }, [consignments]);

  return (
    <Row className="list-footer">
      <Col>
        <Descriptions size="default" column={1}>
          <Descriptions.Item
            label={
              <TextIcon
                type="check"
                color="green"
                title={intl.formatMessage({
                  id: "consignment.list.footer.canBeSend",
                  defaultMessage: "Tyto zásilky je možné odeslat do DHL!",
                })}
                text={intl.formatMessage({
                  id: "consignment.list.footer.countOfValid",
                  defaultMessage: "Počet validních zásilek",
                })}
              />
            }
          >
            <Text strong>{countOfValid}</Text>
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <TextIcon
                type="warning"
                color="red"
                title={intl.formatMessage({
                  id: "consignment.list.footer.cannotBeSend",
                  defaultMessage:
                    "Tyto zásilky není možné odeslat do DHL, je nutné doplnit povinné atributy!",
                })}
                text={intl.formatMessage({
                  id: "consignment.list.footer.countOfInvalid",
                  defaultMessage: "Počet nevalidních zásilek",
                })}
              />
            }
          >
            <Text strong>{countOfInvalid}</Text>
          </Descriptions.Item>
        </Descriptions>
      </Col>
    </Row>
  );
}

export default ListFooter;
